/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { ChartData } from '../../../charts/models/ChartData';

@Component({
  selector: 'app-ctv-ivt',
  templateUrl: './ctv-ivt.component.html',
  styleUrls: ['./ctv-ivt.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtvIvtComponent implements OnChanges {
  @Input() data: any;
  @Input() isFollowing: boolean;
  @Input() isFreemium: boolean;

  maxValue: number;
  tooltipMapping = {
    appSpoofing:
      'Traffic where the app identifier (e.g. bundleId) reported to the exchange does not match the characteristics of the app detected by Pixalate.',
    clickFarm:
      'An impression originating from a user who has been flagged as being associated with human click farm activity.',
    cookieStuffing:
      'Activity from a cookie which has connected to the internet via a statistically significant inflated number of different IP Addresses.',
    datacenterProxy:
      'The impression is from an intermediary proxy device, running in a datacenter, that exists to manipulate traffic counts, pass non-human or invalid traffic or which fails to comply with protocol.',
    defaseApp:
      'Traffic sourced from mobile apps that have been delisted from their respective app stores.',
    deviceIdStuffing:
      'Activity from a device which has connected to the internet via a statistically significant inflated number of different IP Addresses.',
    displayClickFraud:
      'Clicks that are generated from the same device at an inflated rate.',
    displayImpressionFraud:
      'Impressions that are generated from the same device at a statistically significant inflated rate.',
    doorwaySite:
      'A user which has been flagged for accessing a given page or domain via multiple spoofed page referrers.',
    highCTRTraffic:
      'Traffic associated with domains or apps demonstrating high risk CTR behavior.',
    highRiskApp:
      'The impression is from an app which has been flagged for a high risk of invalid traffic.',
    highRiskDeviceId:
      'The impression is from a device ID which has been flagged for a high risk of invalid traffic.',
    highRiskDomain:
      'The impression is from a domain which has been flagged for a high risk of invalid traffic.',
    highRiskIP:
      'The impression is from an IP Address which has been flagged for a high risk of invalid traffic.',
    hijackedSession:
      'Activity originating from a device which has a statistically significant inflated number of user sessions.',
    IPObfuscation:
      'An IP which has been spoofed such that the impression is rendered to a different IP address than the one originally offered.',
    locationObfuscation:
      'Activity originating from an IP where multiple impressions deviate from the geographic location that is reported in the advertising transaction.',
    malware: 'The impression is from domains or pages known to host malware.',
    maskedIP:
      'The IP of a user does not match the IP and the associated ISP reported in the advertising transaction.',
    phishing:
      'The impression is from domains or pages associated with phishing tactics.',
    proxy:
      'The impression is from an intermediary proxy device that exists to manipulate traffic counts, pass non-human or invalid traffic or which fails to comply with protocol.',
    publisherFraud:
      'Publishers operating domains or apps which violate standard ad serving practices including, for example, stacked ads, high ad density and inflated impression counts.',
    smartbot:
      'Bots (or users) that change their browser agent string (spoofing) and cookies very often under the same IP, creating low volume traffic or high volume traffic under configuration that looks like a busy enterprise network.',
    videoClickFraud:
      'Video ad clicks that are generated from the same device at a statistically significant inflated rate.',
    videoImpressionFraud:
      'Video ad impressions that are generated from the same device at a statistically significant inflated rate.',
    autoreloader:
      'Impressions with very periodic patterns that cannot be generated by a human.',
    blankUserAgent: 'The impression has an empty User Agent field.',
    datacenter:
      'The User’s IP has a match in the Pixalate known Datacenter list.',
    duplicateClicks:
      'High volumes of duplicate clicks which may indicate an integration issue.',
    duplicateImpressions:
      'High volumes of duplicate impressions which may indicate an integration issue.',
    fastClicker:
      'Activity originating from users which generate clicks less than one second apart from their respective impression.',
    IABcrawler:
      'Activity originating from bots that use a User Agent string which matches a User Agent on the list of IAB known crawlers.',
    IABdummyBot:
      'Activity originating from bots that use a User Agent string which does not match any existing browser.',
    idioBots:
      'Bots (or users) that change their User Agent string (spoofing), while keeping the same cookie.',
    privateIP:
      'The IP Address associated with the ad impression is from the private network space.',
    TOR: 'Traffic originating from a TOR network node.'
  };
  barChartData: Array<ChartData>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      if (
        this.data &&
        this.data.ivtDistribution &&
        this.data.ivtDistribution.sivtFraudTypes &&
        this.data.ivtDistribution.sivtFraudTypes.length > 0
      ) {
        this.maxValue =
          this.data.ivtDistribution.sivtFraudTypes[0].totalTrafficRatio;
      }

      if (
        this.data &&
        this.data.ivtDistribution &&
        this.data.ivtDistribution.givtFraudTypes &&
        this.data.ivtDistribution.givtFraudTypes.length > 0
      ) {
        const curr =
          this.data.ivtDistribution.givtFraudTypes[0].totalTrafficRatio;
        if (curr > this.maxValue) {
          this.maxValue = curr;
        }
      }

      if (this?.data?.ivtDistribution?.byMonth) {
        this.barChartData = this?.data?.ivtDistribution?.byMonth;
        this.barChartData.reverse();
      }
    }
  }
}
